import {
  Component,
  OnDestroy,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { ActivatedRoute, Params, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { UiStackControllerService } from 'src/app/cc-api/services';
import { STACK_WRITE } from 'src/app/constants/permissions';
import { FacetsPage } from 'src/app/facets/facets-page/facets-page.component';
import { RbacButton } from 'src/app/models/rbac-button.interface';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import { triggerAnalyticsEvent } from 'src/app/utils/analytics/trigger-analytics';
import cloneDeep from 'lodash/cloneDeep';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
})
export class ProjectsComponent extends FacetsPage {
  PROJECTS_PROJECT = 'PROJECTS_PROJECT';
  projectsActionButtons: RbacButton[] = [
    {
      id: 'create-project',
      title: 'New Project',
      buttonType: 'primary',
      status: 'primary',
      icon: 'plus-outline',
      iconPack: 'fci',
      action: STACK_WRITE,
      onClick: () => {
        this.openCreateProjectForm();
      },
    },
  ];
  @ViewChild('projectCreateFormPopup', { static: true })
  private projectCreateFormPopup: TemplateRef<any>;

  allProjects = [];
  loading: boolean = false;
  searchKey = new UntypedFormControl('');
  filteredProjects = [];
  originalProjectsList = [];
  checkSearch: boolean = false;
  showTemplates: UntypedFormControl = new UntypedFormControl(false);
  mode: string = 'Projects';
  filterProjectsOptions = [
    { value: 'Projects', label: 'Projects' },
    { value: 'Test Projects', label: 'Test Projects' },
    { value: 'Templates', label: 'Templates' },
  ];

  emptyStateDescription: { [key: string]: string[] } = {
    Projects: [
      'Projects are cornerstone of effective software architecture.',
      'Create your first one to get started.',
    ],
    Templates: [
      'Templates are projects that have been saved as template while creating the blueprint.',
    ],
    'Test Projects': [
      'Test Projects are used to test custom modules before publishing them to other projects.',
    ],
  };

  // queryParamsSubscription: any;
  constructor(
    _route: ActivatedRoute,
    private dialogService: NbDialogService,
    private stackController: UiStackControllerService,
    private featureFlagService: FeatureFlagsService,
    private router: Router,
  ) {
    super(_route);
  }

  OnPageLoad(p: Params): void {
    this.getAllProjects();

    // setTimeout(() => {
    //   const currentUrlTree = this.router.parseUrl(this.router.url);
    //   if (currentUrlTree?.queryParams?.['onboarding-flow']) {
    //     currentUrlTree.queryParams = {};
    //     const newUrl = currentUrlTree.toString();
    //     this.router.navigateByUrl(newUrl, { replaceUrl: true });
    //   }
    // }, 30000);
  }

  handleProjectActions(event) {
    this.projectsActionButtons.find((btn) => btn?.id === event)?.onClick();
  }

  openCreateProjectForm() {
    this.dialogService
      .open(this.projectCreateFormPopup, { closeOnBackdropClick: false })
      .onClose.subscribe((data) => {
        if (data?.status) {
          this.getAllProjects();
        }
      });
  }

  getAllProjects() {
    this.loading = true;
    this.allProjects = [];
    this.filteredProjects = [];
    this.stackController.getStacksUsingGET1().subscribe(
      (data) => {
        this.filteredProjects = cloneDeep(data).filter(
          (project) => !project?.previewModulesAllowed && !project?.template,
        );
        this.allProjects = cloneDeep(this.filteredProjects);
        this.originalProjectsList = cloneDeep(data);
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      },
    );
  }

  onSearchProject(value: string) {
    const trimmedValue = value?.trim();
    this.searchKey.setValue(trimmedValue, { emitEvent: false });
    triggerAnalyticsEvent(`${this.PROJECTS_PROJECT}_SEARCH`);
    if (!trimmedValue) {
      this.filteredProjects = this.allProjects;
      return;
    }
    this.filteredProjects = this.allProjects?.filter(
      (project) =>
        project?.name?.toLowerCase()?.includes(trimmedValue.toLowerCase()) ||
        project?.description
          ?.toLowerCase()
          ?.includes(trimmedValue.toLowerCase()),
    );
  }

  onFilterProject(filterType: string) {
    triggerAnalyticsEvent(`PROJECTS_PROJECT_SHOW_${filterType?.toUpperCase()}`);
    this.mode = filterType;

    const filterMap = {
      Templates: (project) => project?.template,
      Projects: (project) =>
        !project?.previewModulesAllowed && !project?.template,
      'Test Projects': (project) => project?.previewModulesAllowed,
    };

    const filterFn = filterMap?.[filterType] || (() => true);
    this.filteredProjects = this.originalProjectsList?.filter(filterFn);

    this.searchKey.reset();
    this.allProjects = cloneDeep(this.filteredProjects);
  }
}
